import LinkSliderService from './link-slider-service'

class SliderService {
    $lv;

    constructor($lv) {
        this.$lv = $lv
    }

    _ins;

    get instance() {
        if (!this._ins) {
            this._ins = this.$lv.newInstance(LinkSliderService)
        }
        return this._ins
    }

    async pick(option) {
        return await this.instance.pick(option)
    }

    freshCount(val){
        this.instance.freshCount(val)
    }
}

export default SliderService;
